var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2060_218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.227 14.3225C28.227 13.3709 28.1499 12.414 27.9853 11.4778H14.78V16.8689H22.342C22.0283 18.6077 21.02 20.1458 19.5436 21.1232V24.6213H24.0551C26.7044 22.1829 28.227 18.582 28.227 14.3225Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.78 28.001C18.5559 28.001 21.7402 26.7612 24.0602 24.6213L19.5487 21.1232C18.2935 21.9771 16.6731 22.4607 14.7852 22.4607C11.1328 22.4607 8.03596 19.9966 6.92481 16.6837H2.26929V20.2898C4.64592 25.0174 9.48663 28.001 14.78 28.001Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91966 16.6837C6.33322 14.9449 6.33322 13.0621 6.91966 11.3234V7.71729H2.26928C0.283612 11.6732 0.283612 16.3339 2.26928 20.2898L6.91966 16.6837Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.78 5.54127C16.776 5.51041 18.7051 6.26146 20.1506 7.64012L24.1477 3.64305C21.6167 1.26642 18.2575 -0.0402103 14.78 0.000943444C9.48663 0.000943444 4.64592 2.98459 2.26929 7.71728L6.91966 11.3234C8.02567 8.00536 11.1276 5.54127 14.78 5.54127Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2060_218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.adb31038ea02ed0a6709da0c7f2421ce.svg";
export { ForwardRef as ReactComponent };